import { useContext } from 'react';

import { PortalAuthContext } from './PortalAuthContext';
import { ClientUserRoleRank, type ClientUserRole, type PortalAuthContextValue } from './types';

export function usePortalAuth(): PortalAuthContextValue {
  const ctx = useContext(PortalAuthContext);
  if (!ctx) throw new Error('usePortalAuth must be used inside <PortalAuthProvider>.');
  return ctx;
}

export function useHasClientRole(minimum: ClientUserRole): boolean {
  const { user } = usePortalAuth();
  if (!user) return false;
  return ClientUserRoleRank[user.role] >= ClientUserRoleRank[minimum];
}
